import React from 'react'

const Plan = () => {
  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      minHeight: '100vh', 
      backgroundColor:'black'
      //backgroundColor:'#151517' 
    }}>
      
    </div>
  )
}

export default Plan;
